import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, watch, onUnmounted, computed } from 'vue';

import {
  SkeletonLoader,
  HelperViewStatus,
  HelperViewContextual
} from '@warrenbrasil/nebraska-web';
import { StatementRow } from './components/StatementRow';

import {
  PortfolioMonthlyStatement,
  getPortfolioMonthlyStatementsList,
  PortfolioMontlhyStatementListFilterOption,
  PortfolioMontlhyStatementListFilters,
  getMonthlyStatement
} from '@/modules/wealth/services/portfolio';
import { forceDownloadHref } from '@/modules/common/helpers/force-download';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { notify } from '@/modules/common/helpers/notification';

interface Props {
  selectedYear?: number | string | null;
  portfolioId: string;
}
interface Emits {
  (
    event: 'on-load',
    portfolioName?: string | null,
    selectedYear?: number | string,
    yearOptions?: PortfolioMontlhyStatementListFilterOption[]
  ): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Statements',
  props: {
    selectedYear: null,
    portfolioId: null
  },
  emits: ["on-load"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'on-load',
    portfolioName?: string | null,
    selectedYear?: number | string,
    yearOptions?: PortfolioMontlhyStatementListFilterOption[]
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedYear?: number | string | null;
  portfolioId: string;
}





const isLoading = ref(false);
const hasError = ref(false);
const filters = ref<PortfolioMontlhyStatementListFilters | null>(null);
const portfolioName = ref<string | null>(null);
const statements = ref<PortfolioMonthlyStatement[]>([]);
const abortSignal = ref<AbortController | null>(null);
const currentStatementIndexDownloading = ref<number | null>(null);

watch(
  () => props.selectedYear,
  async () => {
    const currentYearOfFetchedData = getSelectedFilterOption(
      filters.value?.years || []
    )?.value;
    if (currentYearOfFetchedData !== props.selectedYear || hasError.value)
      await getStatements();
  }
);

const hasStatements = computed(() => statements.value.length > 0);

const isDownloadingStatement = computed(() => {
  return currentStatementIndexDownloading.value !== null;
});

const handleDownloadStatement = async (index: number) => {
  try {
    const statement = statements.value[index];
    if (!statement.hasStatement) {
      notify({
        group: 'wrn-notifications',
        text: 'Você não possui extrato no período selecionado',
        type: NotificationTypes.info
      });
      return;
    }

    currentStatementIndexDownloading.value = index;

    const data = await getMonthlyStatement({
      portfolioId: props.portfolioId,
      month: statement.month.value,
      year: props.selectedYear!
    });

    forceDownloadHref(
      `data:application/pdf;base64,${data.base64}`,
      `${statement.month.formatted} - ${props.selectedYear}`
    );
  } catch {
    notify({
      group: 'wrn-notifications',
      text: `Não foi possível iniciar o download`,
      type: NotificationTypes.error
    });
  } finally {
    currentStatementIndexDownloading.value = null;
  }
};

const getSelectedFilterOption = (
  options: PortfolioMontlhyStatementListFilterOption[]
) => {
  return options.find(option => option.active);
};

const getStatements = async () => {
  if (abortSignal.value) {
    abortSignal.value.abort();
  }
  abortSignal.value = new AbortController();

  try {
    isLoading.value = true;
    hasError.value = false;

    const params = {
      portfolioId: props.portfolioId,
      year: props.selectedYear
    };

    const data = await getPortfolioMonthlyStatementsList(
      params,
      abortSignal.value.signal
    );

    portfolioName.value = data.portfolio.name;
    filters.value = data.filters;
    statements.value = data.statements;

    const selectedYear = getSelectedFilterOption(
      filters.value?.years || []
    )?.value;
    emit('on-load', portfolioName.value, selectedYear, filters.value?.years);
  } catch {
    emit('on-load');

    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

onMounted(async () => {
  await getStatements();
});

onUnmounted(() => {
  if (abortSignal.value) {
    abortSignal.value.abort();
  }
});

return { __sfc: true,props, emit, isLoading, hasError, filters, portfolioName, statements, abortSignal, currentStatementIndexDownloading, hasStatements, isDownloadingStatement, handleDownloadStatement, getSelectedFilterOption, getStatements, SkeletonLoader, HelperViewStatus, HelperViewContextual, StatementRow }
}

})